import React from "react";
import logo from "./images/logo.svg";
import time from "./images/ico_time.png";
import { useNavigate } from "react-router-dom";
import Footer from "./Footer.jsx";
import styles from "./css/helper.module.scss";
const Helper = () => {
    const navigate = useNavigate();

    const handleNavigate = (path) => {
        navigate(path);
    };

    return (
        <div>
            <header className={styles.header}>
                <div className={styles.logo}>
                    <img src={logo} title="logo" />
                </div>
                <div className={styles.nav}>
                    <span style={{ marginRight: '45px' }} onClick={() => handleNavigate("/")}>首页</span>
                    <span style={{ color: "#ff4338", marginRight: '45px' }} onClick={() => handleNavigate("/helper")}>使用帮助</span>
                    <span onClick={() => handleNavigate("/about")}>关于我们</span>
                </div>
            </header>

            <div className={styles.main}>
                <div className={styles.listCon}>
                    <div className={styles.list}>
                        <div className={styles.firstList}>
                            <div className={styles.left}>ZIP压缩包打不开？教你5步解决常见问题</div>
                            <div className={styles.right}>
                                <img src={time}/>
                                <span>2025-04-25</span>
                            </div>
                        </div>
                        <div className={styles.secondList}>
                            <p>1. 常见问题原因分析</p>
                            <p>文件打不开、解压失败、格式不兼容……这些问题你是否遇到过？</p>
                        </div>
                        <div onClick={() => handleNavigate("/PageDetails?page=1")} className={styles.thirdList}>查看详情</div>
                    </div>

                    <div className={styles.list}>
                        <div className={styles.firstList}>
                            <div className={styles.left}>如何一键批量解压多个压缩文件？</div>
                            <div className={styles.right}>
                                <img src={time}/>
                                <span>2025-04-25</span>
                            </div>
                        </div>
                        <div className={styles.secondList}>
                            <p>1. 常见问题原因分析</p>
                            <p>文件打不开、解压失败、格式不兼容……这些问题你是否遇到过？</p>
                        </div>
                        <div onClick={() => handleNavigate("/PageDetails?page=2")} className={styles.thirdList}>查看详情</div>
                    </div>

                    <div className={styles.list}>
                        <div className={styles.firstList}>
                            <div className={styles.left}>解压失败是什么原因？附解决办法大全</div>
                            <div className={styles.right}>
                                <img src={time}/>
                                <span>2025-04-25</span>
                            </div>
                        </div>
                        <div className={styles.secondList}>
                            <p>1. 常见问题原因分析</p>
                            <p>文件打不开、解压失败、格式不兼容……这些问题你是否遇到过？</p>
                        </div>
                        <div onClick={() => handleNavigate("/PageDetails?page=3")} className={styles.thirdList}>查看详情</div>
                    </div>

                    <div className={styles.list}>
                        <div className={styles.firstList}>
                            <div className={styles.left}>云启Zip支持哪些格式？压缩解压全兼容解析</div>
                            <div className={styles.right}>
                                <img src={time}/>
                                <span>2025-04-25</span>
                            </div>
                        </div>
                        <div className={styles.secondList}>
                            <p>1. 常见问题原因分析</p>
                            <p>文件打不开、解压失败、格式不兼容……这些问题你是否遇到过？</p>
                        </div>
                        <div onClick={() => handleNavigate("/PageDetails?page=4")} className={styles.thirdList}>查看详情</div>
                    </div>

                    <div className={styles.list}>
                        <div className={styles.firstList}>
                            <div className={styles.left}>解压速度太慢怎么办？这5招帮你提速</div>
                            <div className={styles.right}>
                                <img src={time}/>
                                <span>2025-04-25</span>
                            </div>
                        </div>
                        <div className={styles.secondList}>
                            <p>1. 常见问题原因分析</p>
                            <p>文件打不开、解压失败、格式不兼容……这些问题你是否遇到过？</p>
                        </div>
                        <div onClick={() => handleNavigate("/PageDetails?page=5")} className={styles.thirdList}>查看详情</div>
                    </div>

                    <div className={styles.list}>
                        <div className={styles.firstList}>
                            <div className={styles.left}>加密压缩包忘记密码？看看这几种应对方案</div>
                            <div className={styles.right}>
                                <img src={time}/>
                                <span>2025-04-25</span>
                            </div>
                        </div>
                        <div className={styles.secondList}>
                            <p>1. 常见问题原因分析</p>
                            <p>文件打不开、解压失败、格式不兼容……这些问题你是否遇到过？</p>
                        </div>
                        <div onClick={() => handleNavigate("/PageDetails?page=6")} className={styles.thirdList}>查看详情</div>
                    </div>

                    <div className={styles.list}>
                        <div className={styles.firstList}>
                            <div className={styles.left}>WinRAR和ZIP格式有什么区别？怎么选？</div>
                            <div className={styles.right}>
                                <img src={time}/>
                                <span>2025-04-25</span>
                            </div>
                        </div>
                        <div className={styles.secondList}>
                            <p>1. 常见问题原因分析</p>
                            <p>文件打不开、解压失败、格式不兼容……这些问题你是否遇到过？</p>
                        </div>
                        <div onClick={() => handleNavigate("/PageDetails?page=7")} className={styles.thirdList}>查看详情</div>
                    </div>

                    <div className={styles.list}>
                        <div className={styles.firstList}>
                            <div className={styles.left}>怎么解压7z文件？详细图文教程来了</div>
                            <div className={styles.right}>
                                <img src={time}/>
                                <span>2025-04-25</span>
                            </div>
                        </div>
                        <div className={styles.secondList}>
                            <p>1. 常见问题原因分析</p>
                            <p>文件打不开、解压失败、格式不兼容……这些问题你是否遇到过？</p>
                        </div>
                        <div onClick={() => handleNavigate("/PageDetails?page=8")} className={styles.thirdList}>查看详情</div>
                    </div>


                    <div className={styles.list}>
                        <div className={styles.firstList}>
                            <div className={styles.left}>电脑解压工具哪个好？云启Zip真实测评</div>
                            <div className={styles.right}>
                                <img src={time}/>
                                <span>2025-04-25</span>
                            </div>
                        </div>
                        <div className={styles.secondList}>
                            <p>1. 常见问题原因分析</p>
                            <p>文件打不开、解压失败、格式不兼容……这些问题你是否遇到过？</p>
                        </div>
                        <div onClick={() => handleNavigate("/PageDetails?page=9")} className={styles.thirdList}>查看详情</div>
                    </div>

                    <div style={{border: 'none'}} className={styles.list}>
                        <div className={styles.firstList}>
                            <div className={styles.left}>云启Zip安全吗？本地解压 + 无上传机制详解</div>
                            <div className={styles.right}>
                                <img src={time}/>
                                <span>2025-04-25</span>
                            </div>
                        </div>
                        <div className={styles.secondList}>
                            <p>1. 常见问题原因分析</p>
                            <p>文件打不开、解压失败、格式不兼容……这些问题你是否遇到过？</p>
                        </div>
                        <div onClick={() => handleNavigate("/PageDetails?page=10")} className={styles.thirdList}>查看详情</div>
                    </div>
                </div>
            </div>


            <Footer />
        </div>
    );
};

export default Helper;
